import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import Vuex from 'vuex'

export default {
  namespaced: true,
  state: {
    index: 1,
    dataList: {
      category: '',
      identity: '',
      entity: '',
      search: '',
      perPage: 25,
      perPageOptions: [10, 25, 50, 100],
      currentPage: 1,
      addedColumns: {
        Core: ['actions'],
      },
      removedColumns: {
        Core: {
          contact: [
            'maritalStatus',
            'contactType',
            'createUser',
            'updateUser'
          ],
          customer: [
            'contact',
            'agentTeam',
            'status',
            'createUser',
            'updateUser'
          ],
          address: [
            'contact',
            'telephoneOffice',
            'fax',
            'chineseCorrespondenceAddress',
            'englishCorrespondenceAddress'
          ],
          agent: [
            'ociLicensePrinciples',
            'ociLicenseGeneral',
            'ociLicenseLongTerm',
            'ociLicenseLinkedLongTerm',
            'ociLicenseTravel',
            'sfcLicenseType1',
            'sfcLicenseType2',
            'sfcLicenseType3',
            'sfcLicenseType4',
            'sfcLicenseType5',
            'sfcLicenseType6',
            'sfcLicenseType7',
            'sfcLicenseType8',
            'sfcLicenseType9',
            'sfcLicenseType10'
          ],
          lead: [],
          message: [
          'referencePolicyType',
          'updateTime'
          ],
          team: [],
          user: [
          'userName',
          'password',
          'userEntityId',
          'lastLoginInfo'

          ],
        },
        OSMLife: {
          product: [
            'productCode',
            'category',
            'version',
            'productChineseName',
            'productCodeByIssuer',
            'issuerOrProviderId',
            'remarks',
            'createUser',
            'updateUser',
            'createTime',
            'updateTime',
            'basicRiderRiderWBasic',
            'subCategory',
            'status',
            'effectiveDateFrom',
            'effectiveDateTo',
            'year1AnnualBonus',
            'year2AnnualBonus',
            // 'policyFeeHkd',
            'policyFeeUsd',
            // 'clawbackMonth',
            'year1Comm',
            'year2Comm',
            'year3Comm',
            'year4Comm',
            'year5Comm',
            'year6plusComm'
          ],
          policy: [

            "policyReference",
            "conditionalAssignmentFlag",
            "productId",
            "productDescription",
            "commencementDate",
            "issueDate",
            "policyTerm",
            "totalSinglePremiumPaid",
            "totalRegularPremiumPaid",
            "totalPremiums",
            "totalWithdrawals",
            "maxPartialSurrenderValue",
            "currentInvestmentValue",
            "bonusAllocationValue",
            "initPremiumBonusPercentage",
            "currentLoanAmount",
            "lifeBasisCode",
            "lifeBasisDescription",
            "originalAgent",
            "originalReferrer",
            "introducerNumber",
            "risOption",
            "initCommPeriodForOriPrem",
            "policyOwner",
            "insurer",
            "beneficiary",
            "thirdParty",
            "postCall",
            "sentOutMedium",
            "sentOutReference",
            "courierNumber",
            "remarks",
            "version",
            // "createUser",
            "updateTime",
            "updateUser",
            "workFlowStep",
            "policyLapseDate",
            "policyEndDate",
            "agentReceiveDate",
            "paymentMethod",
            "paymentTerm"

          ],
          policyPremium: [],
          paymentHistory: [],
          policyFund: [],
          investmentStrategy: [],
          transactionHistory: [],
          outstandingRequirement: [],
          outstandingRequirementComment: [],
          insuredBenefits: [],
          pendingOperation: [
          'policyId'
          ],
          commission: [
            "policyId",
            "commissionTypeDescription",
            "descriptionOfPremium",

          ],
          commissionOverride: [
          'underliningCommissionId'],
        },
        OSMGI: {
          generalPolicy: [

            //           "ID",
            "productId",
            // "policyNumber",
            // "policyReference",
            "productDescription",
            // "policyStatus",
            // "policyCurrency",
            // "newBusinessOrRenewal",
            // "policyType",
            // "issueDate",
            "applicationDate",
            "applicationReceiveDate",
            // "effectiveDate",
            // "expiryDate",
            "postCall",
            "subPolicyId",
            "originalAgent",
            "currentAgent",
            "ownerCustomer",
            "insuredCustomer",
            "agentCommission",
            "premiumPaid",
            "grossPremium",
            "levyOrMib",
            "agentCommissionRate",
            "agentCommissionPaid",
            "agentNetToFfs",
            "ffsIncome",
            "insurerRebate",
            "chequeToInsurer",
            "chequeToInsurerNumber",
            "chequeIssueDate",
            "remarks",
            "version",
            "paymentMethod",
            "premiumAmount",
            "policyFee",
            "customerActuallyPaid",
            "sentOutDate",
            "sentOutMedium",
            "sentOutReference",
            // "companyReceiveDate",
            "customerReceiveDate",
            "agentReceiveDate",
            "policyLapseDate",
            "policyEndDate",
            "policyReinstateDate",
            // "workFlow",
            // "workFlowStep",
            // "approveAgent",
            // "approveDate",
            // "createTime",
            "updateTime",
            // "createUser",
            "updateUser"
          ],
          loanContract: [],
        },
        DM: {
          document: [],
        },
        System: {
          systemLogs: [],
          entitlement: [],
        }
      },
      fields: [], // Removed uesless columns and add slots
      columns: [],
      total: 100,
      list: []
    },
    dataAction: {
      ID: '',
      type: '',
      data: {}
    }
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Adm/EntityManagement/store/index.js